if (!customElements.get('quantity-input-bundles')) {
  class QuantityInputBundles extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this,))
      );
    }


    connectedCallback() {
      this.validateQtyRules();
    }

    disconnectedCallback() {
    }

    onInputChange() {
      this.validateQtyRules();
      this.updateCartQuantity();

      // 确保输入值在 min 和 max 范围内
      if (!this.input.value || isNaN(this.input.value) || parseInt(this.input.value) < parseInt(this.input.min)) {
        this.input.value = this.input.min || 1;
        this.input.dispatchEvent(this.changeEvent);
      }
      if (this.input.max && parseInt(this.input.value) > parseInt(this.input.max)) {
        this.input.value = this.input.max;
        this.input.dispatchEvent(this.changeEvent);
      }
    }

    onButtonClick(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      const previousValue = this.input.value;
      if (button.name === 'plus') {
        if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
          this.input.value = this.input.dataset.min;
        } else {
          this.input.stepUp();
          console.log(this.input.stepUp)
        }
      } else {
        this.input.stepDown();
      }

      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

      if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
        this.input.value = parseInt(this.input.min);
      }
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        buttonPlus.classList.toggle('disabled', value >= max);
      }
    }

    updateCartQuantity() {
      const value = parseInt(this.input.value) || 1;
      // 优先在同一产品底部区域查找 add-cart-button，再回退到 document
      const container = this.closest('.card-product-4__buy-button');
      let cart = container ? container.querySelector('add-cart-button') : null;
      if (cart) {
        cart.setAttribute('data-quantity', value);
        cart.dataset.quantity = String(value);
      }
    }
  }
  customElements.define('quantity-input-bundles', QuantityInputBundles);
}